module.exports = __webpack_public_path__ + "img/droplet-percent.2e87ab30.svg";